export const notF = <T>(f: (item: T) => boolean) => {
  return (item: T) => !f(item);
};
